import { Help } from '@material-ui/icons';
import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import '../style/informativoOnboarding.css';

const InformativoOnboarding = ({ titulo, children }) => {
  return (
    <div>
      <Accordion allowZeroExpanded style={{ backgroundColor: '#f5f5f5', fontSize: '14px', marginTop: '10px' }}>
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>
              <Help className="icone-informativo" />
              {titulo}
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>{children}</AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default InformativoOnboarding;
